"use client";

import Image from "next/image";
import { useEffect, useRef } from "react";
import useTheme from "src/context/appThemeContext";

function PartnerCard({ image, name, DarkImage }) {
  const { theme } = useTheme();

  const imgSrc = theme === "dark" ? DarkImage : image;
  return (
    <div className="sp-partner-card swiper-slide">
      <div className="sp-logo-wrapper">
        <Image src={imgSrc} alt={name || "Partners Logo"} width={160} height={80} sizes="(max-width: 768px) 80px, 100px" className="object-contain" loading="lazy" />
      </div>
    </div>
  );
}

export default function PartnerSlider({ items }) {
  const swiperRef = useRef(null);

  useEffect(() => {
    let swiperInstance = null;

    const init = async () => {
      const { Swiper } = await import("swiper");
      const { Autoplay } = await import("swiper/modules");

      swiperInstance = new Swiper(swiperRef.current, {
        modules: [Autoplay],
        loop: true,
        slidesPerView: 5,
        spaceBetween: 0,
        speed: 600,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: { slidesPerView: 2 },
          540: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 7 },
        },
      });
    };

    init();

    return () => {
      swiperInstance?.destroy(true, true);
    };
  }, []);

  return (
    <>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" />
      <div ref={swiperRef} className="swiper sp-swiper-wrapper">
        <div className="swiper-wrapper">
          {items.map((p, i) => (
            <PartnerCard key={i} {...p} />
          ))}
        </div>
      </div>
    </>
  );
}
